<div class="fup-container">

  <div class="file-upload-container noselect" [ngStyle]="containerStyles()">

    <ng-container *ngIf="!processing; else processingSpinner">

      <div class="editable-image noselect mat-elevation-z1" (click)="fileUpload.click()" [ngClass]="stateClasses()"
        [ngStyle]="editableImageStyles()" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">


        <img class="empty-image noselect" [src]="componentShape === 'square' ? EMPTY_IMG_SQUARE : CARD_EMPTY_IMG"
          *ngIf="!src && emptyImage">

        <input class="file-upload noselect" type="file" (change)="onFileSelected($event)"
          (click)="onInputClicked(fileUpload)" [accept]="accept" #fileUpload>

        <div class="edit-image-control noselect" *ngIf="editMode">
          <mat-icon>mode_edit</mat-icon>
        </div>

      </div>

    </ng-container>

    <ng-template #processingSpinner>

      <mat-spinner [diameter]="75" class="processing-ongoing"></mat-spinner>

    </ng-template>

  </div>

  <div class="delete-file noselect" *ngIf="allowDelete && src" (click)="onDelete()">

    <mat-icon matTooltip="Delete">delete</mat-icon>

  </div>


</div>